import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { getThemeColor } from 'web-app/styleguide/color-helpers';
import { hasValue } from '@famly/stat_ts-utils_has-value';
import { currentTheme } from 'web-app/styleguide';
/**
 * Adds some standard props to an SVG element
 */
export const StandardSVG = (props) => {
    const { size, children, className, ...restProps } = props;
    const squareSize = getSizeFromSizeDescription(size);
    return (_jsx("svg", { width: squareSize, height: squareSize, className: className, viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', ...restProps, children: children }));
};
export const getSizeFromSizeDescription = (size) => {
    switch (size) {
        case 'Small':
            return 20;
        case 'Medium':
            return 24;
        case 'Large':
            return 32;
        case 'SelfScaling':
            return undefined;
        default: {
            return size;
        }
    }
};
export const getColorOrDefault = (color) => {
    if (!hasValue(color)) {
        return getThemeColor('text');
    }
    if (typeof color === 'string') {
        return getThemeColor(color);
    }
    return currentTheme().mf.colorPalette[color.color];
};
